var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 156,
    viewBox: "0 0 229 156",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M110.607 134.626C139.326 134.626 162.607 111.345 162.607 82.6264C162.607 53.9076 139.326 30.6264 110.607 30.6264C81.8881 30.6264 58.6069 53.9076 58.6069 82.6264C58.6069 111.345 81.8881 134.626 110.607 134.626Z",
    fill: "#E6ECF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.6069 48.1264C84.6069 41.7751 79.4582 36.6264 73.1069 36.6264C66.7556 36.6264 61.6069 41.7751 61.6069 48.1264C61.6069 54.4777 66.7556 59.6264 73.1069 59.6264C79.4582 59.6264 84.6069 54.4777 84.6069 48.1264Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.321 36.6264C71.0042 36.6264 68.7394 37.3134 66.813 38.6006C64.8867 39.8878 63.3852 41.7172 62.4986 43.8577C61.612 45.9982 61.38 48.3535 61.832 50.6258C62.284 52.8981 63.3997 54.9854 65.0379 56.6236C66.6762 58.2619 68.7634 59.3775 71.0357 59.8295C73.3081 60.2815 75.6634 60.0496 77.8038 59.1629C79.9443 58.2763 81.7738 56.7749 83.061 54.8485C84.3481 52.9221 85.0352 50.6573 85.0352 48.3405C85.0261 45.2365 83.789 42.2623 81.5941 40.0674C79.3993 37.8726 76.425 36.6355 73.321 36.6264Z",
    fill: "#56D187"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M73.7496 42.3405H72.8925C72.5769 42.3405 72.321 42.6987 72.321 43.1405V53.5405C72.321 53.9823 72.5769 54.3405 72.8925 54.3405H73.7496C74.0652 54.3405 74.321 53.9823 74.321 53.5405V43.1405C74.321 42.6987 74.0652 42.3405 73.7496 42.3405Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.321 48.7691V47.9119C79.321 47.5964 78.9744 47.3405 78.5469 47.3405H68.0952C67.6677 47.3405 67.321 47.5964 67.321 47.9119V48.7691C67.321 49.0847 67.6677 49.3405 68.0952 49.3405H78.5469C78.9744 49.3405 79.321 49.0847 79.321 48.7691Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M111.107 69.6264C114.324 69.6264 117.51 70.2601 120.483 71.4914C123.455 72.7226 126.156 74.5272 128.431 76.8023C130.706 79.0773 132.511 81.7782 133.742 84.7507C134.973 87.7231 135.607 90.909 135.607 94.1264V112.626C135.607 114.283 134.264 115.626 132.607 115.626H89.6069C87.9501 115.626 86.6069 114.283 86.6069 112.626V94.1264C86.6069 87.6286 89.1882 81.3969 93.7828 76.8023C98.3775 72.2076 104.609 69.6264 111.107 69.6264Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M116.607 67.6264C116.607 64.3127 113.921 61.6264 110.607 61.6264C107.293 61.6264 104.607 64.3127 104.607 67.6264V70.6264C104.607 73.9401 107.293 76.6264 110.607 76.6264C113.921 76.6264 116.607 73.9401 116.607 70.6264V67.6264Z",
    fill: "#DDE4EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M100.607 72.1079L104.618 80.6264L108.607 76.6758L104.618 70.6264L100.607 72.1079Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M100.607 72.1229L104.607 80.6264L108.607 76.6651L104.607 70.6264L102.776 71.181C102.597 71.2349 102.422 71.2996 102.251 71.3746L100.607 72.1229Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M120.607 71.972L116.587 80.6264L112.607 76.799L116.698 70.6264L120.607 71.972Z",
    fill: "black"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M120.607 71.9825L116.607 80.6264L112.607 76.7884L116.7 70.6264L117.451 70.8311C118.261 71.0542 119.055 71.3262 119.829 71.6456L120.607 71.9825Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M110.611 68.6263C112.768 68.6323 114.869 67.9546 116.607 66.6928C116.379 65.28 115.649 63.9939 114.548 63.0653C113.448 62.1368 112.049 61.6266 110.602 61.6264C109.157 61.6287 107.761 62.1398 106.662 63.0682C105.563 63.9966 104.835 65.2815 104.607 66.6928C106.348 67.9564 108.452 68.6342 110.611 68.6263Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M110.607 66.6264C117.234 66.6264 122.607 61.2538 122.607 54.6264C122.607 47.999 117.234 42.6264 110.607 42.6264C103.98 42.6264 98.6069 47.999 98.6069 54.6264C98.6069 61.2538 103.98 66.6264 110.607 66.6264Z",
    fill: "#8792A8"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M110.607 68.6264C116.13 68.6264 120.607 64.1493 120.607 58.6264C120.607 53.1036 116.13 48.6264 110.607 48.6264C105.084 48.6264 100.607 53.1036 100.607 58.6264C100.607 64.1493 105.084 68.6264 110.607 68.6264Z",
    fill: "#DDE4EE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M102.607 48.3972L105.134 51.441C105.134 51.441 116.216 52.4101 117.48 49.9169C118.743 47.4237 110.184 45.6264 110.184 45.6264L102.607 48.3972Z",
    fill: "#8792A8"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M101.607 48.3971L104.64 51.441C104.64 51.441 117.938 52.4101 119.454 49.9169C120.97 47.4236 110.699 45.6264 110.699 45.6264L101.607 48.3971Z",
    fill: "#8792A8"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M100.607 59.6264C101.159 59.6264 101.607 58.9548 101.607 58.1264C101.607 57.298 101.159 56.6264 100.607 56.6264C100.055 56.6264 99.6069 57.298 99.6069 58.1264C99.6069 58.9548 100.055 59.6264 100.607 59.6264Z",
    fill: "#DDE4EE"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M120.607 59.6264C121.159 59.6264 121.607 58.9548 121.607 58.1264C121.607 57.298 121.159 56.6264 120.607 56.6264C120.055 56.6264 119.607 57.298 119.607 58.1264C119.607 58.9548 120.055 59.6264 120.607 59.6264Z",
    fill: "#DDE4EE"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M113.607 155.159C157.79 155.159 193.607 153.473 193.607 151.393C193.607 149.313 157.79 147.627 113.607 147.627C69.4242 147.627 33.607 149.313 33.607 151.393C33.607 153.473 69.4242 155.159 113.607 155.159Z",
    fill: "url(#paint0_radial)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8325 57.4164C23.5939 57.4164 25.8325 55.1778 25.8325 52.4164C25.8325 49.655 23.5939 47.4164 20.8325 47.4164C18.0711 47.4164 15.8325 49.655 15.8325 52.4164C15.8325 55.1778 18.0711 57.4164 20.8325 57.4164Z",
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7275 7.41644C72.3264 7.41644 73.6225 6.1203 73.6225 4.52142C73.6225 2.92255 72.3264 1.6264 70.7275 1.6264C69.1286 1.6264 67.8325 2.92255 67.8325 4.52142C67.8325 6.1203 69.1286 7.41644 70.7275 7.41644Z",
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M224.506 129.416C226.105 129.416 227.401 128.12 227.401 126.521C227.401 124.922 226.105 123.626 224.506 123.626C222.907 123.626 221.611 124.922 221.611 126.521C221.611 128.12 222.907 129.416 224.506 129.416Z",
    stroke: "#246EFF",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M4.54443 86.0864V92.0864",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60693 89.3364H1.60693",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M209.794 27.8364V33.8364",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M212.857 31.0864H206.857",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M150.56 11.4492V17.4492",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M153.623 14.6992H147.623",
    stroke: "#A7C5FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(113.607 151.393) rotate(90) scale(3.7664 80)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6ECF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6ECF7",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.843e8dbce29269b5bc788e42ba1f0a24.svg";
export { ForwardRef as ReactComponent };